import * as React from 'react';
import { ProductBlockGallery } from '@grandvisionhq/lib-visuals';
import { getRecommendationKey } from '../../utils/get-recommendation-key.js';
import { BannerRecommendationBlock } from '../BannerRecommendationBlock/BannerRecommendationBlock.js';
import { ProductRecommendationBlock } from '../ProductRecommendationBlock/ProductRecommendationBlock.js';

const RecommendationsGallery = ({ recommendations , itemsPerSlide , navigationLocation , shouldRenderBlocksAsCards ,  })=>{
    const renderBlock = ({ blockKey , className , tabIndex  })=>{
        const recommendationIndex = recommendations.findIndex((recommendation)=>{
            const key = getRecommendationKey(recommendation);
            return blockKey === key;
        });
        const recommendation1 = recommendations[recommendationIndex];
        if (!recommendation1) {
            return null;
        }
        if (recommendation1.recommendationType === 'banner') {
            return /*#__PURE__*/ React.createElement(BannerRecommendationBlock, {
                key: blockKey,
                className: className,
                recommendation: recommendation1,
                shouldRenderAsCard: shouldRenderBlocksAsCards,
                tabIndex: tabIndex
            });
        }
        return /*#__PURE__*/ React.createElement(ProductRecommendationBlock, {
            key: blockKey,
            className: className,
            recommendation: recommendation1,
            shouldRenderAsCard: shouldRenderBlocksAsCards,
            position: recommendationIndex + 1,
            tabIndex: tabIndex
        });
    };
    const blockKeys = recommendations.map(getRecommendationKey);
    return /*#__PURE__*/ React.createElement(ProductBlockGallery, {
        isLoading: false,
        hasError: false,
        blockKeys: blockKeys,
        renderBlock: renderBlock,
        itemsPerSlide: itemsPerSlide,
        navigationLocation: navigationLocation
    });
};

export { RecommendationsGallery };
//# sourceMappingURL=RecommendationsGallery.js.map
